import React from 'react';
import ButtonIconBase from './ButtonIconBase';
import classNames from 'classnames';

function ButtonIconOverlay(props) {
    let buttonClasses = classNames('btn-overlay', props.className);

    return <ButtonIconBase {...props} className={buttonClasses} />;
}

ButtonIconOverlay.propTypes = {
    ...ButtonIconBase.propTypes
};

ButtonIconOverlay.defaultProps = {
    ...ButtonIconBase.defaultProps
};

export default ButtonIconOverlay;
